import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import HandOffLink from '../../../utils/urls/HandOffLink';

import colors from '../../../styling/colors';
import { navFinished } from '../../../redux/nav';

const NodeLinkMixin = () => `
  color: ${colors('lapel')};
  display: flex;
  justify-content: space-between;
  text-decoration: none;
  width: 100%;
`;

const Container = styled.div`
  display: flex;
  justify-content: ${({ hasLink }) => (!hasLink ? 'space-between' : '')};
`;

const NodeLink = styled.a`
  ${NodeLinkMixin()};
`;

const TrackedNodeLink = styled(HandOffLink)`
  ${NodeLinkMixin()};
`;

export class Node extends Component {
  static propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    isActive: PropTypes.bool,
    isLeaf: PropTypes.bool.isRequired,
    navFinished: PropTypes.func.isRequired,
    node: PropTypes.shape({
      href: PropTypes.string,
      path: PropTypes.string,
    }).isRequired,
    onClick: PropTypes.func.isRequired,
  };

  finalNodeHander = e => {
    const {
      navFinished,
      node: { href, path },
    } = this.props;

    navFinished(href, path);
  };

  render() {
    const {
      children,
      className,
      isActive,
      isLeaf,
      level,
      node: { href },
      onClick,
    } = this.props;

    const hasLink = !!href;

    const LinkComponent = isLeaf ? TrackedNodeLink : NodeLink;

    const clickHandler = isLeaf ? this.finalNodeHander : onClick;

    const content = hasLink ? (
      <LinkComponent
        href={href}
        onClick={isLeaf ? undefined : e => e.preventDefault()}
      >
        {children}
      </LinkComponent>
    ) : (
      children
    );

    return (
      <Container
        className={className}
        hasLink={hasLink}
        isActive={isActive}
        onClick={clickHandler}
        level={level}
      >
        {content}
      </Container>
    );
  }
}

const mapDispatchToProps = { navFinished };

export default connect(null, mapDispatchToProps)(Node);
